import { Switch } from '@mui/material';
import { useMaterialUIController } from 'context';

const MDSwitch = ({ value, disabled, setFieldValue, campo, isDashboard = false }) => {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    return (
        <Switch
            disabled={disabled}
            checked={value}
            onChange={(event) => {
                if (isDashboard) {
                    setFieldValue(event.target.checked)
                } else {
                    setFieldValue(campo, event.target.checked)
                }
            }}
            sx={{
                '& .MuiSwitch-switchBase.Mui-checked': {
                    color: '#557cff !important',
                },
                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: '#557cff !important',
                },
            }} />

    );
};

export default MDSwitch;
